import React from "react";
import "../Services/Services.css";
const Services = () => {
  return (
    <>
      <div>
        <div className="Simg">
          <img src="./eimg/services.jpg" alt="" />
        </div>
        <div className="Scentered">
          <h1>Essendant Fulfillment Services</h1>
          {/* <h1>MEHAK meriiii jaan</h1> */}
        </div>
      </div>
      <div className="padding">
        <div className="Sutext">
          <h1>FUEL YOUR GROWTH WITH EXPERTS IN FULFILLMENT</h1>
          <h2 className="b">
            The supply chain is more complex than ever – Essendant simplifies it
            for you.
          </h2>
          <h2>
            With our world-class distribution network, operational excellence
            and supply chain expertise, we can design a streamlined fulfillment
            solution that expands your selling options, improves your customer
            service and saves you time so you can focus on building your
            business.
          </h2>
        </div>
        <div>
          <div className="Sudis">
            <hr />
            <h1 className="h1">
              SOLUTIONS THAT EXPAND YOUR REACH & OPTIMIZE YOUR SUPPLY CHAIN
            </h1>
          </div>
        </div>
        <div className="disu">
          <div className="dflex Ti">
            <div>
              <img src="./eimg/supplychain-1.svg" alt="" />
            </div>
            <div className="Tchain">
              <h3>Network Design & Optimization</h3>
              <h3 className="b">
                With <b>33 owned and strategically located facilities</b>,
                Essendant’s reach brings you closer to your customers. Our
                supply chain experts can design a network of fulfillment centers
                that
                <b>
                  streamlines your service, reduces freight costs and mitigates
                  risk.
                </b>
              </h3>
            </div>
          </div>
          <div className="dflex Ti">
            <div>
              <img src="./eimg/supplychain-2.svg" alt="" />
            </div>
            <div className="Tchain">
              <h3>Drop Shipping</h3>
              <h3 className="b">
                Our national coverage means
                <b>we reach 98% of the population next day.</b>We blind ship as
                an extension of your supply chain to both residential and
                commercial customers.
              </h3>
            </div>
          </div>
          <div className="dflex Ti">
            <div>
              <img src="./eimg/supplychain-3.svg" alt="" />
            </div>
            <div className="Tchain">
              <h3>B2B & B2C Fulfillment</h3>
              <h3 className="b">
                <b>
                  We’re B2B and B2C, shipping to all business types and
                  consumers.
                </b>
                We ship LTL, FTL or Parcel, reaching your desired customers
                across channels. Plus, our flexible solutions accommodate any
                measure.
              </h3>
            </div>
          </div>
          <div className="dflex Ti">
            <div>
              <img src="./eimg/supplychain-4.svg" alt="" />
            </div>
            <div className="Tchain">
              <h3>Ecommerce & Marketplace Fulfillment</h3>
              <h3 className="b">
                To <b>streamline your order fulfillment, </b> we partner with
                the platforms and marketplaces you sell through.
              </h3>
            </div>
          </div>
          <div className="dflex Ti">
            <div>
              <img src="./eimg/supplychain-5.svg" alt="" />
            </div>
            <div className="Tchain">
              <h3>Inventory Management</h3>
              <h3 className="b">
                We store, manage, track and report to give you clear visibility
                to inventory levels.
                <b>
                  Essendant’s wholesale position helps make product lifecycle
                  management easy,
                </b>
                from new product launch to end of life.
              </h3>
            </div>
          </div>
          <div className="dflex Ti">
            <div>
              <img src="./eimg/supplychain-6.svg" alt="" />
            </div>
            <div className="Tchain">
              <h3>Value Added Services</h3>
              <h3 className="b">
                We’ve got samples, kitting, virtual bundling, Amazon Prime
                fulfillment and custom logo boxes covered too. With our
                capabilities and flexibility,
                <b>
                  we’re ready to handle your customers’ needs that may be
                  atypical for your operations.
                </b>
              </h3>
            </div>
          </div>
        </div>

        <div>
          <div className="Sndis">
            <h1 className="h1">
              <b>DISTRIBUTION </b> IS WHAT WE DO
            </h1>
            <hr />
          </div>
        </div>
        <div className="Sbox">
          <div className="dbox">
            <img src="./eimg/distribution-1.svg" alt="" />
            <h1>190K</h1>
            <h3>lines filled daily*</h3>
          </div>
          <div className="dobox">
            <img src="./eimg/distribution-2.svg" alt="" />
            <h1>360K</h1>
            <h3>packages filled daily*</h3>
          </div>
          <div className="dbox">
            <img src="./eimg/distribution-3.svg" alt="" />
            <h1>50K</h1>
            <h3>nationally drop shipped orders daily*</h3>
          </div>
          <div className="dobox">
            <img src="./eimg/distribution-4.svg" alt="" />
            <h1>99.89%</h1>
            <h3>inventory accuracy</h3>
          </div>
          <div className="dbox">
            <img src="./eimg/distribution-5.svg" alt="" />
            <h1>98%</h1>
            <h3>of US population gets next-day delivery</h3>
          </div>
        </div>
        <div>
          <div className="Stdis">
            <hr />
            <h1 className="h1">OUR SCALE & FLEXIBILITY ENABLE YOUR GROWTH</h1>
          </div>
          <div className="map">
            <h3>
              Essendant’s vast and established national network is an efficient,
              cost-effective way for manufacturers to seamlessly scale to add
              capacity where it’s needed.
            </h3>
            <img src="./eimg/fulfillment-map.svg" alt="" />
          </div>
          <div className="srd">
            <div className="sl">
              <img src="./eimg/map-1.svg" alt="" />
              <h2>Next-Day Delivery Zone</h2>
            </div>
            <div className="sl">
              <img src="./eimg/map-3.svg" alt="" />
              <h2>Distribution Center</h2>
            </div>
            <div className="sl">
              <img src="./eimg/map-2.svg" alt="" />
              <h2>Two-Day Delivery Zone</h2>
            </div>
            <div className=" sl">
              <img src="./eimg/map-4.svg" alt="" />
              <h2>Seller Fulfilled Amazon Prime Locations</h2>
            </div>
          </div>
          <div className="gbox dflex">
            <div>
              <img src="./eimg/growth-1.svg" alt="" />
              <h1>30</h1>
              <h3>Centrally-located DCs</h3>
            </div>
            <div>
              <img src="./eimg/growth-2.svg" alt="" />
              <h1>9+</h1>
              <h3>Million Sq. Feet</h3>
            </div>
            <div>
              <img src="./eimg/growth-3.svg" alt="" />
              <h1>10K</h1>
              <h3>Customers</h3>
            </div>
          </div>
        </div>
      </div>

      <div className="Ssec">
        <div className="St">
          <h1>HOW OUR FULFILLMENT SERVICES WORK</h1>
          <h3>
            We’ll work together to design a solution that meets your goals. Then
            we act as your invisible supply chain partner, seamlessly handling
            every step of fulfillment for you.
          </h3>
        </div>
        <div className="fs">
          <div className="circle">
            <h1>1</h1>
          </div>
          <img src="./eimg/services-1.svg" alt="" />
          <h2>
            We consult with you to understand your go-to-market strategy, design
            the network to optimize service and cost, and onboard for execution.
          </h2>
        </div>
        <div className="fs">
          <div className="circle">
            <h1>2</h1>
          </div>
          <img src="./eimg/services-2.svg" alt="" />
          <h2>You send us your orders.</h2>
        </div>
        <div className="fs">
          <div className="circle">
            <h1>3</h1>
          </div>
          <img src="./eimg/services-3.svg" alt="" />
          <h2>
            We quickly pick and pack in a range of measures: each, carton,
            pallet.
          </h2>
        </div>
        <div className="fs">
          <div className="circle">
            <h1>4</h1>
          </div>
          <img src="./eimg/services-4.svg" alt="" />
          <h2>
            We blind ship to your customer in a range of modes: parcel, LTL,
            FTL.
          </h2>
        </div>
      </div>
      <div className="sb">
        <h1>ESSENDANT FULFILLMENT SERVICES – DELIVERING BIG BENEFITS</h1>
        <div className="sf">
          <div className="Sbbox">
            <img src="./eimg/check.svg" alt="" />
            <h3>
              Unlock your opportunities for growth with new channel access,
              simple and cost-effective new product introduction and more
              selling options.
            </h3>
          </div>

          <div className="Sbbox">
            <img src="./eimg/check.svg" alt="" />
            <h3>
              Work with experts in fulfillment with 100 years of distribution
              experience, uniquely positioned in the market to power a wide
              range of supply chain solutions.
            </h3>
          </div>
        </div>
        <div className="sf3">
          <div className="Sf3box">
            <img src="./eimg/check.svg" alt="" />
            <h3>
              Gain efficiencies and streamline your supply chain by reducing
              your shipments and inventory on hand and increasing your
              resilience to supply chain challenges.
            </h3>
          </div>
        </div>
      </div>
      <div className="Ssec">
        <div className="st">
          <div className="stag">
            <h2>Let’s find the supply chain solution to fuel your growth.</h2>
            <h3>Fill out the form below to get started.</h3>
          </div>
          <div className="sti">
            <h3>
              If you do not have product inventory ownership and instead,
              purchase product as you receive customer orders, you may be
              looking for Wholesale Drop Ship support. Please complete the
              Reseller Form here to get in touch with Essendant’s Wholesale
              Distribution account set up team.
            </h3>
            <div className="stiin">
              <div>
                <h3>First Name:*</h3>
                <input type="input" />
              </div>
              <div>
                <h3>Last Name:*</h3>
                <input type="input" />
              </div>
              <div className="stinm">
                <h3>Email:*</h3>
                <input type="email" />
              </div>
              <div className="stinm">
                <h3>Company Name:*</h3>
                <input type="input" />
              </div>
              <h3 style={{ color: "rgba(228, 157, 4, 0.925)" }}>
                Please complete this required field.
              </h3>
              <h3 style={{ color: "rgba(228, 157, 4, 0.925)" }}>
                Please complete this required field.
              </h3>
            </div>
            <h3>
              How would we receive your products to be stored at Essendant’s
              distribution centers? Select all that apply.*
            </h3>
            <h4 className="f1 clr">
              With Essendant Fulfillment Services, you maintain full ownership
              of your product inventory. We receive, store, and ship product on
              your behalf.
            </h4>
            <div className="chk">
              <input type="checkbox" />
              <label> Pallets</label>
              <br></br>
              <input type="checkbox" />
              <label> Mixed Pallets</label>
              <br></br>
              <input type="checkbox" />
              <label> LTL or FTL</label>
              <br></br>
              <input type="checkbox" />
              <label> Containers</label>
              <br></br>
            </div>
            <h3>Are you currently using a Third Party Logistics Provider?*</h3>
            <input className="in" type="text" />
            <h3>
              What are the supply chain/logistics challenges you are looking to
              address?*
            </h3>
            <input className="in" type="text" />
            <div  className="sibtn">
            <button>SUBMIT</button>

            </div>
          </div>
        </div>
      </div>
      <hr className="Cline" />
    </>
  );
};

export default Services;
